import React from "react";
import { useDispatch } from "react-redux";
import { setIsFormFocused } from "../../../redux/actions";

interface Props {
    isFormInputFocused: boolean;
}

export default function InputFocusRenderer(props: Props) {
    const { isFormInputFocused } = props;
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!isFormInputFocused) {
            const questionToFocus = document.querySelector(".question--error");
            if (questionToFocus) {
                if (questionToFocus.scrollIntoView) {
                    questionToFocus.scrollIntoView(true);
                }
                const focusableSelector =
                    '.allowFocusOnQuestion, button, [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
                const focusables = Array.from(
                    questionToFocus.querySelectorAll(focusableSelector),
                ) as HTMLElement[];
                const emptyInput = focusables.find((el) => {
                    const v = (el as HTMLInputElement).value;
                    return v !== undefined && v.trim() === "";
                });
                const inputToFocus = emptyInput || focusables[0];

                if (inputToFocus) {
                    inputToFocus.focus();

                    dispatch(setIsFormFocused(true));
                }
            }
        }
    });

    return <></>;
}
